import {React, useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import axios from 'axios';
import '../../App.css'
import {Grid, TextField, Box, Button, Paper, Stack,FormControl, FormControlLabel, InputLabel, Select, MenuItem, Checkbox, FormHelperText, Typography} from '@mui/material';
import {PersonAddAlt1} from '@mui/icons-material';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';

const calculatedOnOptions = [
  {id: 1, title: "CTC"},
  {id: 2, title: "Basic"},
]

const criteriaOptions = [
  {id: 1, title: "Percent"},
  {id: 2, title: "Manual"},
]

const initialFValues={
  id: 0,
  allowanceName: '',
  calculatedOn: '',
  criteria: '',
  percent: 0.00,
  isActive: false,
  effectiveDate: new Date(),
}

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

function AddNewAllowanceForm(props){

  const [allowances, setAllowances] = useState({});
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  const dispatch = useDispatch();


  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});

  useEffect(() => {
      if (notify.isOpen && notify.type === 'success') {
        // Close the modal after a short delay to show the notification
        const timer = setTimeout(() => {
          // Call the parent's function to close the modal
          if (props.onCloseModal) {
            props.onCloseModal();
          }
        }, 100);
        
        return () => clearTimeout(timer);
      }
    }, [notify, props.onCloseModal]);

  useEffect(()=>{
    async function getAllEmployees(){
      if(props.fetch_id) {
        try {
          const response =  await axios.get(`${process.env.REACT_APP_API_BASE_URL}/configure/ctc-configure/get-allowance/` + props.fetch_id);
          if(response.status === 200 && response.data.length > 0) {
            const allowanceData = response.data[0];
            
            setValues({
              ...values,
              allowanceName: allowanceData.Allowance || '',
              calculatedOn: allowanceData.calculatedon || '',
              criteria: allowanceData.Criteria || '',
              percent: allowanceData.percents || 0.00,
              isActive: allowanceData.Allowstatus === 1 || false,
            });
          }
        } catch (e) {
          if(e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            },1000);
          }
        }
      }
    }
    getAllEmployees();
  }, [props.fetch_id]);

  const validate = () => {
    let temp = {}
    temp.allowanceName = values.allowanceName ? "" : "This field is required."
    temp.criteria = values.criteria.length != 0 ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()) {
      if(props.fetch_id) {
        // Edit existing allowance
        const payload = {
          allowanceName: values.allowanceName,
          criteria: values.criteria,
          calculatedOn: values.calculatedOn,
          percent: parseFloat(values.percent) || 0,
          isActive: values.isActive ? 1 : 0,
          // company_id: 163 // You might want to get this from props or context
        };

        axios.put(`${process.env.REACT_APP_API_BASE_URL}/configure/ctc-configure/edit-allowance/${props.fetch_id}`,payload)
        .then(function (response) {
          if(response.status === 200) {
            setNotify({
              isOpen: true,
              message: response.data.message || 'Allowance updated successfully',
              type: 'success'
            });
            dispatch(updateTableActions.startUpdateAllowances());
          } 
        })
        .catch(function (e) {
          handleApiError(e);
        });
      } else {
        // Add new allowance
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/configure/ctc-configure/add-new-allowance`, values)
        .then(function (response) {
          if(response.status === 200) {
            setNotify({
              isOpen: true,
              message: response.data.message || 'Allowance added successfully',
              type: 'success'
            });
            dispatch(updateTableActions.startUpdateAllowances());
            resetForm();
          } 
        })
        .catch(function (e) {
          handleApiError(e);
        });
      }
    }
  }

  const handleApiError = (e) => {
    if(e.response.status === 401) {
      setNotify({
        isOpen: true,
        message: 'Session Expired!',
        type: 'error'
      });
      setTimeout(() => {
        navigate('/');
      },1000);
    } else if (e.response.status === 422) {
      setNotify({
        isOpen: true,
        message: e.response.data.error_message?.sqlMessage || 'An error occurred',
        type: 'error'
      });
    } else {
      setNotify({
        isOpen: true,
        message: 'An error occurred. Please try again.',
        type: 'error'
      });
    }
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "-10px", padding: "30px", fontWeight: "500px"}}>
      <Paper  variant="outlined" elevation={5} sx={{width: "400px", marginTop: "-20px"}}>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={2} sx={{margin: "30px"}}>
            <TextField
              variant="outlined"
              name="allowanceName"
              label={<RequiredLabel label="Allowance Name"/>}
              size="small"
              value={values.allowanceName}
              onChange={handleInputChange}
              {...(errors.allowanceName && {error:true, helperText: errors.allowanceName} )}
            />

            <FormControl
              variant="outlined"
              {...(errors.criteria && {error:true} )}>
                <InputLabel><RequiredLabel label="Criteria"></RequiredLabel></InputLabel>
                <Select
                  label="Criteria"
                  name="criteria"
                  size="small"
                  value={values.criteria}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                    {
                      criteriaOptions.map(
                        item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                      )
                    }

                </Select>
                { errors.criteria && <FormHelperText>{errors.criteria}</FormHelperText>}
            </FormControl>

            <FormControl>
              <FormControlLabel
                control={<Checkbox
                        name="isActive"
                        color="primary"
                        size="small"
                        checked={values.isActive}
                        onChange={ e => handleInputChange(convertToDefEventPara("isActive", e.target.checked))}
                        />}
                        label="Active"
                        />
            </FormControl>

            {values.criteria == "Percent" ?
            <>
            <FormControl
              variant="outlined"
              {...(errors.calculatedOn && {error:true} )}>
                <InputLabel>Calculated On</InputLabel>
                <Select
                  label="Calculated On"
                  name="calculatedOn"
                  size="small"
                  value={values.calculatedOn}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                    {
                      calculatedOnOptions.map(
                        item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                      )
                    }

                </Select>
                { errors.calculatedOn && <FormHelperText>{errors.calculatedOn}</FormHelperText>}
            </FormControl>

            <TextField
              variant="outlined"
              label="Percent"
              name="percent"
              size="small"
              value={values.percent}
              onChange={handleInputChange}
              {...(errors.percent && {error:true, helperText: errors.percent} )}
            />
            </>
            :""}

            <Stack className="center-aligned" sx={{padding: "20px"}}>
              <TextField
                variant="outlined"
                className="date-picker"
                type="date"
                label="Effective Date"
                name="effectiveDate"
                value={values.effectiveDate}
                onChange={handleInputChange}
              />
            </Stack>

            <Grid container className="space-around">
              <Grid item>
              <Button variant="contained" color="error" onClick={resetForm}>Reset</Button>
              </Grid>
              <Grid item>
              <Button variant="contained" type="submit" color="success">
                {props.fetch_id ? 'Update' : 'Submit'}
              </Button>
              </Grid>
            </Grid>

            </Stack>
        </form>

      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify} 
      />
    </Box>
  )
}

export default AddNewAllowanceForm;